/**
 * Persistence Service for Customers in rn-equote
 * Delegates all storage operations to CustomerRepository (Drizzle ORM + IndexedDB).
 */
import type { Customer } from '../screens/M15CustomerListScreen';
import { customerRepository } from '../repositories/CustomerRepository';

/** Async retrieval of saved customers from CustomerRepository */
export const getSavedCustomersAsync = async (): Promise<Customer[]> => {
  return await customerRepository.getAll();
};

/** Sync fallback for legacy components */
export const getSavedCustomersLocal = (): Customer[] => {
  // Trigger async load, return cached/repo state
  let data: Customer[] = [];
  customerRepository.getAll().then((res) => {
    data = res;
  });
  return data;
};

export const getCustomerByIdLocal = (id: string): Customer | undefined => {
  let found: Customer | undefined;
  customerRepository.getById(id).then((res) => {
    found = res;
  });
  return found;
};

export const getCustomerByIdAsync = async (id: string): Promise<Customer | undefined> => {
  return await customerRepository.getById(id);
};

export const saveCustomerLocal = (
  data: Omit<Customer, 'id' | 'createdAt' | 'updatedAt' | 'created_at' | 'updated_at'>
): Customer => {
  const nowIso = new Date().toISOString();
  const dateStr = nowIso.split('T')[0];
  const newEntry: Customer = {
    ...data,
    id: `KH-LOCAL-${Date.now()}`,
    createdAt: dateStr,
    updatedAt: nowIso,
    created_at: nowIso,
    updated_at: nowIso,
    isLocal: true,
  };

  customerRepository.save(data);
  return newEntry;
};

export const saveCustomerAsync = async (
  data: Omit<Customer, 'id' | 'createdAt' | 'updatedAt' | 'created_at' | 'updated_at'>
): Promise<Customer> => {
  return await customerRepository.save(data);
};

export const updateCustomerLocal = (id: string, partialData: Partial<Customer>): Customer | undefined => {
  customerRepository.update(id, partialData);
  return undefined;
};

export const updateCustomerAsync = async (id: string, partialData: Partial<Customer>): Promise<Customer | undefined> => {
  return await customerRepository.update(id, partialData);
};

export const deleteCustomerLocal = (id: string): Customer[] => {
  customerRepository.delete(id);
  return [];
};

export const deleteCustomerAsync = async (id: string): Promise<Customer[]> => {
  return await customerRepository.delete(id);
};
